import * as React from "react";
import { RefundRequest } from "../../../../../application/domain/payment/refund-request";
import { RefundTotal } from "./calculate-result";
import { RefundItemTable } from "./refund-item-table";

type RefundPaymentProps = {
  refundRequest: RefundRequest;
  setRefundRequest: (value: RefundRequest) => void;
  confirm?: boolean;
};

export const RefundPayment: React.FC<RefundPaymentProps> = ({
  refundRequest,
  setRefundRequest,
  confirm,
}) => {
  return (
    <>
      <RefundItemTable
        confirm={confirm}
        refundRequest={refundRequest}
        onChange={setRefundRequest}
      />
      <RefundTotal
        paymentResult={
          refundRequest.isValid() ? refundRequest.getTotalRefundAmount() : 0
        }
      />
    </>
  );
};
